import React, { useContext, useEffect, useReducer } from "react";
// import { ExclusiveType } from "../../../AppConstants/TypeConstants";
// import { AREA_OF_INTEREST } from "../../../AppData/AreaOfInterest";
import {
  Profession_DATA,
  hideSpecialityForProfession,
  showEmployeeCodeForProfession,
} from "../../../AppData/Profession";
import { SPECIALITY_DATA } from "../../../AppData/Speciality";
import closeBtn from "../../../assets/images/close.png";
import LoaderImg from "../../../assets/images/Loader.gif";
import { UserContext } from "../../../contexts/UserContext/UserContextProvider";
import { filterNullObjectKeys, showToast, validateEmail } from "../../../utils/common.utils";
import {
  whiteListCountries,
  CITY_DEBOUNCE,
  CITY_FETCH_MIN_CHAR,
} from "../../../AppConstants/Constants";
import styles from "./EditProfile.module.scss";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import * as Yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";
import { onUserProfilePush } from "../../../Clevertap/events";
import { usersAPI } from "../../../apis/usersAPI";
import CustomDropDown from "../../CustomDropDown";

const schema = Yup.object({
  firstName: Yup.string()
    .required("First Name is required")
    .test(
      "min-length",
      "First Name should have a minimum length of 2",
      (value) => {
        if (value) {
          return value.trim().length >= 2;
        }
        return true; // Let required() handle empty values
      }
    )
    .max(50, "First Name should have a maximum length of 50")
    .matches(/^[a-zA-Z ]+$/, "First Name should contain only alphabets")
    .label("First Name"),

  lastName: Yup.string()
    .required("Last Name is required")
    .min(2, "Last Name should have a minimum length of 2")
    .max(50, "Last Name should have a maximum length of 50")
    .matches(/^[a-zA-Z ]+$/, "Last Name should contain only alphabets")
    .label("Last Name"),

  email: Yup.string()
    .email("Enter a valid Email")
    .test("validateEmail", "Please enter a valid Email", (value) => validateEmail(value))
    .required("Email is required")
    .label("Email"),

  phoneNumber: Yup.string()
    .required("Mobile Number is required")
    .matches(/^[+]?[0-9]+$/, "Mobile Number should be a valid number")
    .test(
      "is-valid-phone-number",
      "Please Enter a valid Mobile Number",
      function (value) {
        return isValidPhoneNumber(value); // Assuming isValidNumber returns true or false
      }
    )
    .label("Mobile Number"),

  locationResult: Yup.object()
    .shape({
      state: Yup.string().nullable().notRequired(),
      city: Yup.string().required("Enter a valid City"),
      country: Yup.string().nullable().notRequired(),
      pincode: Yup.number().nullable().notRequired(),
      location: Yup.object()
        .shape({
          lat: Yup.number().nullable().notRequired(),
          lng: Yup.number().nullable().notRequired(),
        })
        .nullable()
        .notRequired(),
    })
    .required("City information is required"),

  profession: Yup.string()
    .test(
      "is-not-null",
      "Please select your Profession",
      (value) => value !== null && value !== undefined
    ) // Custom test to reject null or undefined
    .oneOf(Profession_DATA, "Please select a valid Profession")
    .required("Please select your Profession")
    .label("Profession"),


  employeeCode: Yup.string()
    .when("profession", {
      is: (profession) =>
        showEmployeeCodeForProfession.includes(profession?.trim()),
      then: (schema) =>
        schema
          .required("Please Enter your Employee Code")
          .matches(/^\d{8}$/, "Please Enter a valid Employee Code "),
      otherwise: (schema) => schema.nullable().notRequired(),
    })
    .label("Employee Code"),

  speciality: Yup.string()
    .when("profession", {
      is: (profession) =>
        !hideSpecialityForProfession.includes(profession?.trim()),
      then: (schema) =>
        schema
          .required("Please select your Speciality")
          .oneOf(SPECIALITY_DATA, "Please search your Speciality"),
      otherwise: (schema) => schema.nullable().notRequired(),
    })
    .label("Speciality"),
});

const inputs = [
  {
    label: "First Name",
    name: "firstName",
    className: "form-control",
    type: "text",
    placeholder: "Enter First Name",
    required: true,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Last Name",
    name: "lastName",
    className: "form-control",
    type: "text",
    placeholder: "Enter Last Name",
    required: true,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Profession",
    name: "profession",
    className: "form-control",
    type: "select",
    placeholder: "Select your Profession",
    data: Profession_DATA,
    required: true,
    disabled: false,
    readOnly: false,
    needSearch: false,
  },
  {
    label: "Employee Code *",
    name: "employeeCode",
    className: "form-control",
    type: "text",
    placeholder: "Enter Your Employee Code",
    required: false,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Speciality",
    name: "speciality",
    className: "form-control",
    type: "select",
    placeholder: "Search your Speciality",
    data: SPECIALITY_DATA,
    required: true,
    disabled: false,
    readOnly: false,
    needSearch: true,
  },

  // {
  //   label: "Area Of Interest",
  //   name: "areaOfInterest",
  //   className: "form-control",
  //   type: "select",
  //   placeholder: "Select your Area Of Interest",
  //   data: AREA_OF_INTEREST,
  //   required: true,
  //   disabled: false,
  //   readOnly: false,
  //   needSearch: false,
  // },
  {
    label: "City",
    name: "city",
    className: "form-control",
    type: "text",
    placeholder: "Please enter full city name",
    required: true,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Email",
    name: "email",
    className: "form-control",
    type: "text",
    placeholder: "Enter email",
    required: true,
    disabled: true,
    readOnly: true,
  },
  {
    label: "Mobile Number",
    name: "phoneNumber",
    className: "form-control",
    type: "text",
    placeholder: "Enter mobile number",
    required: true,
    disabled: true,
    readOnly: true,
  },
];

const defaultErr = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  speciality: "",
  profession: "",
  description: "",
  employeeCode: "",
  city: "",
};

const initialState = {
  isLoading: false,
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  speciality: "",
  profession: "",
  city: "",
  locationResult: {
    state: "",
    city: "",
    country: "",
    pincode: null,
    location: {
      lat: 20.5937,
      lng: 78.9629,
    },
  },
  employeeCode: "",
  isPlaceManuallySelected: true,
  errors: {
    ...defaultErr,
  },
};

const Action_Type = {
  handleInputChange: "handleInputChange",
  handleInitialInput: "handleInitialInput",
  handleCityInput: "handleCityInput",
  handleError: "handleError",
  loading: "loading",
};

const reducer = (state, action) => {
  let { type, payload } = action;

  switch (type) {
    case Action_Type.handleInitialInput:
    case Action_Type.handleError:
    case Action_Type.loading:
      return { ...state, ...payload };
    case Action_Type.handleInputChange:
      return { ...state, [payload.name]: payload.value };
    case Action_Type.handleCityInput: {
      return {
        ...state,
        locationResult: {
          ...state.locationResult,
          [payload.name]: payload.value,
        },
      };
    }

    default:
      return { ...state };
  }
};

const EditProfile = ({ handleEditProfile }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { userBasicDetails, user } = useContext(UserContext);

  useEffect(() => {
    if (userBasicDetails) {
      let obj = {
        ...userBasicDetails,
      };
      if (userBasicDetails.city) {
        let locationResult = {
          state: userBasicDetails.state,
          city: userBasicDetails.city,
          country: userBasicDetails.country,
          pincode: userBasicDetails.pincode,
          location: {
            lat: userBasicDetails.latitude,
            lng: userBasicDetails.longitude,
          },
        };
        Object.assign(obj, { locationResult: locationResult });
      }
      dispatch({
        type: Action_Type.handleInitialInput,
        payload: obj,
      });
    }
  }, [userBasicDetails]);

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    dispatch({
      type: Action_Type.handleInputChange,
      payload: { name, value },
    });

    if (name == 'profession') {
      dispatch({
        type: Action_Type.handleInputChange,
        payload: { name: "speciality", value: "" },
      });
    }
  };

  const handleSubmit = async () => {
    try {
      dispatch({
        type: Action_Type.loading,
        payload: { isLoading: true, errors: defaultErr },
      });
      let error = await validateForm();
      if (!isValidForm(error)) {
        dispatch({
          type: Action_Type.loading,
          payload: { isLoading: false },
        });
        return;
      }

      let obj = {
        userId: user.uid,
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        phoneNumber: state.phoneNumber,
        speciality: state.speciality,
        profession: state.profession,
        employeeCode: state.employeeCode,
        ...state.locationResult,
      };

      if (state.employeeCode) {
        obj["employeeCode"] = state.employeeCode;
      }
      if (!obj.pincode) {
        delete obj.pincode;
      }
      // if (state.speciality && state.profession && state.areaOfInterest) {
      //   obj.current_plan = ExclusiveType.PREMIUM;
      // }
      await usersAPI.updateUser(filterNullObjectKeys(obj));
      onUserProfilePush(obj);
      showToast("Data updated successfully.");
      handleEditProfile(false);

      dispatch({
        type: Action_Type.loading,
        payload: { isLoading: false },
      });
    } catch (error) {
      const { data: err } = error;
      let errors = state.errors;
      if (err.code) {
        errors.description = err.message;
      }
      showToast(
        err.message || "Internal Server Error. Please try again later",
        {
          type: "error",
        }
      );
      dispatch({
        type: Action_Type.loading,
        payload: { isLoading: false, errors: errors },
      });
    }
  };

  const handlePlaceSelect = async (address, placeId, suggestion) => {
    try {
      let resp = await geocodeByAddress(address);
      let addressObject = resp[0];

      let lat = addressObject.geometry?.location.lat();
      let lng = addressObject.geometry?.location.lng();
      if (!lat) {
        lat = 20.5937;
      }
      if (!lng) {
        lng = 78.9629;
      }

      let locationResult = {
        state: "",
        city: "",
        country: "",
        pincode: null,
        location: {
          lat,
          lng,
        },
      };

      addressObject.address_components.forEach((element) => {
        if (element.types.indexOf("locality") !== -1) {
          locationResult.city = element.long_name;
        } else if (
          element.types.indexOf("administrative_area_level_1") !== -1
        ) {
          locationResult.state = element.long_name;
        } else if (element.types.indexOf("country") !== -1) {
          locationResult.country = element.long_name;
        } else if (element.types.indexOf("postal_code") !== -1) {
          locationResult.pincode = element.long_name;
        }
      });

      if (!locationResult.city) {
        locationResult.city = locationResult.state;
      }
      dispatch({
        type: Action_Type.handleInitialInput,
        payload: { locationResult: locationResult, city: address, isPlaceManuallySelected: true },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const validateForm = async () => {
    let errors = { ...defaultErr };
    errors.defaultError = "";
    try {
      await schema.validate({ ...state }, { abortEarly: false });
    } catch (error) {
      if (error.inner) {
        error.inner.some((err) => {
          const fieldName = err.path;
          const errorMessage = err.message;
          if (fieldName) {
            fieldName == "locationResult.city"
              ? (errors.city = errorMessage)
              : (errors[fieldName] = errorMessage);
            return true;
          }
        });
      }
    }
    !state.isPlaceManuallySelected && (errors.city = "Please select City from the dropdown");
    let cityData = document.getElementById("city").value;
    cityData.length < 1 && (errors.city = "Please Enter Your City");

    dispatch({
      type: Action_Type.handleError,
      payload: { errors: { ...errors } },
    });
    return errors;
  };

  const isValidForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
    return valid;
  };

  const onCityError = (errCode) => {
    let error = "";
    switch (errCode) {
      case "ZERO_RESULTS":
        error = "No result found.";
        break;
      default:
        error = "Some internal error occurred.";
        break;
    }
    dispatch({
      type: Action_Type.handleError,
      payload: { errors: { city: error } },
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.profileHeader}>
        <div className={styles.heading}>My Profile</div>
        <div
          className={styles.closeBtn}
          onClick={() => handleEditProfile(false)}
        >
          <img src={closeBtn} alt="close" />
        </div>
      </div>
      <div className={styles.inputsContainer} onSubmit={handleSubmit}>
        {inputs.map((input) => {
          if (input.name === "speciality") {
            if (!state.profession?.trim()) {
              return;
            }
            if (
              hideSpecialityForProfession.includes(state.profession?.trim())
            ) {
              return;
            }
          }
          if (
            input.name === "employeeCode" &&
            !showEmployeeCodeForProfession.includes(state.profession)
          ) {
            return;
          }
          return (
            <React.Fragment key={input.name}>
              <div key={input.name} className={styles.inputContainer}>
                <label htmlFor={input.name}>{input.name === "speciality" ? <>{input.label} <span className={styles.specialitySearchText}>(Search your Speciality)</span></> : input.label}</label>
                {input.type === "select" ? (
                  input.needSearch ? (
                    <CustomDropDown
                      className={`${input.className}`}
                      options={input.data}
                      input={input}
                      value={state[input.name] ?? input.placeholder}
                      onSelect={(data) => {
                        dispatch({
                          type: Action_Type.handleInputChange,
                          payload: { name: input.name, value: data },
                        });
                      }}
                    />
                  ) : (
                    <select
                      defaultValue={input.placeholder}
                      id={input.name}
                      name={input.name}
                      className={`${input.className} ${styles.dp}`}
                      type={input.type}
                      placeholder={input.placeholder}
                      required={input.required}
                      value={state[input.name] ?? input.placeholder}
                      onChange={(e) => handleInputChange(e)}
                    >
                      <option value="none">{input.placeholder}</option>

                      {input.data.map((val) => (
                        <option value={val} key={val}>
                          {val}
                        </option>
                      ))}
                    </select>
                  )
                ) : input.name === "city" ? (
                  <PlacesAutocomplete
                    onError={onCityError}
                    value={state[input.name]}
                    onChange={(value) => {
                      dispatch({
                        type: Action_Type.handleInitialInput,
                        payload: { city: value, isPlaceManuallySelected: false },
                      });
                    }}
                    onSelect={handlePlaceSelect}
                    searchOptions={{
                      // sessionToken: sessionToken,
                      types: ["(cities)"],
                      fields: ["address_components"],
                      // componentRestrictions: {
                      //   country: whiteListCountries,
                      // },
                    }}
                    debounce={CITY_DEBOUNCE}
                    shouldFetchSuggestions={
                      state[input.name]?.length >= CITY_FETCH_MIN_CHAR
                    }
                  >
                    {({
                      getInputProps,
                      suggestions,
                      getSuggestionItemProps,
                      loading,
                    }) => (
                      <div style={{ position: "relative" }}>
                        <input
                          className="form-control"
                          {...getInputProps({
                            placeholder: input.placeholder,
                            name: input.name,
                            id: input.name,
                            required: input.required,
                            disabled: input.disabled,
                            readOnly: input.readOnly,
                          })}
                        />
                        <div
                          style={{
                            position: "absolute",
                            zIndex: "10",
                            border: `${suggestions.length === 0
                                ? "0px"
                                : "1px solid rgba(255, 255, 255, 0.4)"
                              }`,
                            width: "100%",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          {loading && <div>Loading...</div>}

                          {suggestions.map((suggestion, index) => {
                            const style = {
                              backgroundColor: suggestion.active
                                ? "#eb4547"
                                : "rgba(44, 64, 103, 1)",
                              color: "#ffff",
                              padding: "0.5rem",
                              cursor: "pointer",
                            };
                            return (
                              <div
                                {...getSuggestionItemProps(suggestion, {
                                  style,
                                })}
                                key={index}
                              >
                                <div
                                  style={{ width: "100%" }}
                                  key={suggestion.description}
                                  value={suggestion.description}
                                >
                                  {suggestion.description}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </PlacesAutocomplete>
                ) : (
                  <input
                    id={input.name}
                    name={input.name}
                    className={input.className}
                    type={input.type}
                    placeholder={input.placeholder}
                    value={state[input.name]}
                    required={input.required}
                    disabled={input.disabled}
                    readOnly={input.readOnly}
                    onChange={(e) => handleInputChange(e)}
                  />
                )}
              </div>
              {state.errors[input.name] && (
                <div
                  className="error"
                  style={{
                    paddingTop: 0,
                    marginTop: "-1rem",
                    paddingBottom: "0.5rem",
                  }}
                >
                  {state.errors[input.name]}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <button
        onClick={handleSubmit}
        type="submit"
        className="btn"
        disabled={state.isLoading ? true : false}
      >
        {state.isLoading ? (
          <img src={LoaderImg} alt="loading..." height="100%" />
        ) : (
          "Save"
        )}
      </button>
    </div>
  );
};

export default EditProfile;
